import {
  Alert,
  Button,
  Col,
  DesignTokens,
  FullWidthSpace,
  LabeledItem,
  Row,
  Space,
  Text,
  Title,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useFormikContext } from "formik";
import { ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse, DisplayFormErrors, DrawerFooterContent } from "melco-shared-logic";
import { ChangeMachineLicensesFormValueType } from "./ChangeMachineLicensesForm";
import dayjs from "dayjs";
import { formatUTCDate } from "../../../../../helper/dateHelper";
import ChangeMachineLicensesChangeTable from "./ChangeMachineLicensesChangeTable";

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

type DisplayChangeMachineLicensesSummaryProps = {
  machineLicensesFormValues?: ChangeMachineLicensesFormValueType;
  machineLicensesDisplayValues: any;
  stepback: () => void;
  disableChangeAndSendEmailButton: boolean;
  currentLicense:
  | ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
  | undefined;
};

const { spacings } = DesignTokens;


const StyledOverviewDiv = styled.div`
  margin-top:15px;
`


export const DisplayChangeMachineLicensesSummary: React.FC<
  DisplayChangeMachineLicensesSummaryProps
> = ({
  stepback,
  machineLicensesFormValues,
  machineLicensesDisplayValues,
  disableChangeAndSendEmailButton,
  currentLicense
}) => {
    const { t } = useTranslation();
    const { submitForm } = useFormikContext();
    console.log("machineLicensesFormValues ", JSON.stringify(machineLicensesFormValues))
    console.log("machineLicensesDisplayValues ", JSON.stringify(machineLicensesDisplayValues))
    return (
      <>
        <FullWidthSpace direction="vertical" size="small">
          <DisplayFormErrors />
          <Title level={4}> {t("machinelicenses.change.form.summary")}</Title>
          <Alert
            type="info"
            closable={false}
            message={t("machinelicenses.change.alert.message")}
          />
          <Row gutter={[spacings.middle, 0]}>
            <Col xs={24} md={8}>
              <Space direction="vertical" size="middle">


                <LabeledItem
                  label={t("machinelicenses.change.form.transaction_id")}
                  content={currentLicense?.transaction_id ?? ""}
                  fallback={t("machinelicenses.change.form.fallback")}
                />


              </Space>
            </Col>
            <Col xs={24} md={8}>
              <Space direction="vertical" size="middle">

                <LabeledItem
                  label={t("machinelicenses.change.form.number_of_assigned_machines")}
                  content={currentLicense?.license_count}
                  fallback="empty"
                />
                <LabeledItem
                  label={t("machinelicenses.change.form.billing_cycle")}
                  content={currentLicense?.subscription_code ?? ""}
                  fallback={t("machinelicenses.change.form.fallback")}
                />
                {(
                  <>
                    <LabeledItem
                      label={t("machinelicenses.change.form.subscription_start_date")}
                      content={
                        dayjs(
                          currentLicense?.subscription_start_date ?? ""
                        ).isValid()
                          ? formatUTCDate(
                            currentLicense?.subscription_start_date
                            , "MM/DD/YYYY")
                          : ""
                      }
                      fallback={t("global.fallback.empty")}
                    />
                    <LabeledItem
                      label={t("machinelicenses.change.form.renewes_on")}
                      content={
                        dayjs(currentLicense?.renews_on ?? "").isValid()
                          ? formatUTCDate(currentLicense?.renews_on, "MM/DD/YYYY")

                          : ""
                      }
                      fallback={t("global.fallback.empty")}
                    />
                  </>
                )}
              </Space>
            </Col>
            <Col xs={24} md={8}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={t("machinelicenses.change.form.owner")}
                  content={
                    <>
                      <Row>{currentLicense?.master_user_name ?? ""}</Row>
                      <Row>{currentLicense?.master_name ?? ""}</Row>
                    </>
                  }
                  fallback={t("machinelicenses.change.form.fallback")}
                />

                <LabeledItem
                  label={t("machinelicenses.change.form.notification_email_address")}
                  content={currentLicense?.email_address ?? ""}
                  fallback={t("machinelicenses.change.form.fallback")}
                />
                <LabeledItem
                  label={t("machinelicenses.change.form.language")}
                  content={
                    currentLicense?.language != ""
                      ? t(`language.${currentLicense?.language}` as any)
                      : ""
                  }
                  fallback={t("machinelicenses.change.form.fallback")}
                />
              </Space>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={24} xl={24}>
              <StyledOverviewDiv>

                <Title level={4}> {t('machinelicenses.change.changetable.account_overview')}</Title>
                <ChangeMachineLicensesChangeTable
                  response={{
                    monthly: currentLicense?.monthly,
                    yearly: currentLicense?.yearly
                  }} />
              </StyledOverviewDiv>
            </Col>
          </Row>
        </FullWidthSpace>
        <DrawerFooterContent>
          <Row>
            <Col xs={24} md={12}>
              <Button
                style={{ minWidth: "80px" }}
                key={"back-btn"}
                type="primary"
                onClick={stepback}
              >
                {t("machinelicenses.buttons.back")}
              </Button>
            </Col>
            <Col
              style={{ display: "flex", justifyContent: "flex-end" }}
              xs={24}
              md={12}
            >
              <Right>
                <Button
                  style={{ minWidth: "80px" }}
                  key="add-user-button"
                  type="primary"
                  onClick={() => submitForm()}
                  disabled={disableChangeAndSendEmailButton}
                >
                  {t("machinelicenses.change.changesendemail")}
                </Button>
              </Right>
            </Col>
          </Row>
        </DrawerFooterContent>
      </>
    );
  };
